/**
 * Returns a display-safe user name, truncated with ellipsis if needed.
 * Replaces the 8-line inline truncation copy-pasted across all pages.
 *
 * @param {object} userData - The userData object from UserContext
 * @param {number} maxLen - Maximum character length (default: 15)
 * @returns {string} Display name
 */
export function getDisplayName(userData, maxLen = 15) {
  const first = userData.user?.firstName || userData.firstName || "";
  const last = userData.user?.lastName || userData.lastName || "";
  const full = `${first} ${last}`.trim();

  if (!full) return userData.username || "User";
  return full.length > maxLen ? full.slice(0, maxLen) + "..." : full;
}
